import localStorageService from "./localStorage.service";

let baseUrl = "";
let accessControlOrigin = "";

switch (process.env.NODE_ENV) {
    case "development":
        baseUrl = "http://127.0.0.1:8000";
        accessControlOrigin = "http://127.0.0.1:8000";
        break;
    default:
        baseUrl = "https://cc-portal-backend-service-6k3dd6vtka-ez.a.run.app";
        accessControlOrigin = "https://cc-portal-2f338.web.app/";
}

class FetchService {
    constructor() {
        return async (url, ...params) => {
            const token = localStorageService.getToken();
            const updatedParams = [ ...params ];

            updatedParams[0].headers["Access-Control-Allow-Origin"] = accessControlOrigin;

            if (token) updatedParams[0].headers["Authorization"] = `Bearer ${token}`;

            const fetchUrl = url.startsWith('/') ? baseUrl + url : url;
            const response = await fetch(fetchUrl, ...updatedParams);

            if (response.status === 403) {
                try {
                    const responseData = await response.clone().json();
                    if (responseData?.error_code === "ENTITLEMENT_DENIED") {
                        if (typeof window !== "undefined" && window.location.pathname !== "/") {
                            window.location.replace("/");
                        }
                    }
                } catch (error) {
                    // Ignore JSON parsing failures and pass the original response through.
                }
            }

            return response;
        }
    }

    getInstance() {
        return this;
    }
}

export default FetchService;

